<template>
  <div class="agent-sales-view">
    <div v-if="agentProperties">
      <div v-if="agentProperties.length === 0">No sale recorded yet</div>
      <div v-else
           class="table-head shadow-box md:ut-flex ut-mb-2 ut-h-12 ut-hidden">
        <div class="section ut-w-3/5">
          <div class="col ut-w-3/5">PROPERTY ADDRESS</div>
          <div class="ut-w-2/5">PROPERTY FEATURES</div>
        </div>
        <div class="section ut-w-2/5">
          <div class="ut-w-1/2">DATE</div>
          <div class="ut-w-1/2">PRICE</div>
        </div>
      </div>
      <agent-property-card
        v-for="property in agentProperties"
        :key="property.key"
        :property="property" />
    </div>

    <loading-spinner v-else />
  </div>
</template>

<script>

import { mapState } from 'vuex';
import AgentPropertyCard from '@/components/Cards/AgentPropertyCard.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';

export default {
  name: 'AccountsSales',
  components: {
    AgentPropertyCard,
    LoadingSpinner,
  },
  data() {
    return {
      agentProperties: null,
    };
  },
  mounted() {
    this.fetchAgentProperties();
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
  },
  methods: {
    fetchAgentProperties() {
      if (this.agent.key) {
        this.$apiServices.oa.property.getAgentProperties(this.agent.key)
          .then((properties) => {
            this.agentProperties = properties.sort((a, b) => new Date(b.saledate) - new Date(a.saledate));
          });
      }
    },
    // gaEvent(eventAction, eventLabel) {
    //   const label = `AID=${this.agent.id}${eventLabel ? ' | ' + eventLabel : ''}`;
    //   return {
    //     category: 'AgentPortal',
    //     action: eventAction,
    //     label
    //   };
    // },
  },
};

</script>

<style lang="scss" scoped>

.table-head{
  border: 1px solid #E3E5E8;
  div {
    @apply ut-text-xs ut-tracking-wide opacity-75;
    opacity: 0.69;
  }
}

  .shadow-box{
      @apply ut-rounded ut-bg-neutral-001 ;
  }

.section {
  @apply ut-mx-0 ut-pl-4;
  display: inline-flex;
}

</style>
